// ************* IMPORTS *************
import moment from "moment";
import "./InfluencerAnalytics.scss";
import { toast } from "react-toastify";
import ReactPaginate from "react-paginate";
import React, { useState, useEffect } from "react";
import { Container, Table } from "react-bootstrap";
import graph from "../../../Assets/sample-graph.png";
import Auctionmodal from "./Auctionmodal/Auctionmodal";
import { useAuth } from "../../../Contexts/auth.context";
import defaultMusicbull from "../../../Assets/defaultMusicbull.png";
import Loading from "../../../components/loading/loading.component";
import { getAuctionDetails } from "../../../Services/auction.service";
import {
  getAuctionBook,
  getAuctionBookInfluencer,
  getReferralCode,
  getTierInfo,
} from "../../../Services/prod/auth.service";
import { CopyIcon, LeftArrowIcon, LiveIcon } from "../../../Assets/svgIcons";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import Countdown from "../../../components/countdown/countdown.component";
import { CMAuctions } from "../../Public/billing-history/billing-history.styles";
import { formatCommaNumbers } from "../../../Utils/common.utils";

const InfluencerAnalytics = () => {
  // ************* STATES *************
  const limit = 10;
  const { auth } = useAuth();
  const location = useLocation();
  const state = location?.state;
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const auctionId = searchParams.get("auctionId");
  const [auctionData, setAuctionData] = useState({});
  const [referralCode, setReferralCode] = useState();
  const [loadingBook, setLoadingBook] = useState(false);
  const [auctionBookData, setAuctionBookData] = useState({
    rows: [],
    TotalRows: 0,
  });
  const [invitationStatus, setInvitationStatus] = useState(
    state?.invitationData?.invitation_status
  );
  const [tierInfo, setTierInfo] = useState({
    tier1_min: 0,
    tier1_max: 0,
    tier2_min: 0,
    tier2_max: 0,
    tier3_min: 0,
    tier3_max: 0,
  });
  const [currentPage, setCurrentPage] = useState(0);
  const [allAuctionBook,setAllAuctionBook]=useState([])
  // ************* CALL AUCTION DETAILS AND AUCTION BOOK API  *************
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        if (auctionId && auth) {
          const [auctionRes, auctionBookRes, bookRes] = await Promise.allSettled([
            getAuctionDetails(auctionId, auth?.userId),
            getAuctionBook({
              action: "iBids_GetBidsByAuctionPagination",
              auction_id: auctionId,
              pageIndex: 1,
              pageCount: limit,
            }),
            getAuctionBookInfluencer(auctionId),
            ]);
          //  Auction Details API
          if (auctionRes.status === "fulfilled") {
            setAuctionData(auctionRes.value);
          } else {
            console.error("API ERROR IN AUCTION DETAILS:", auctionRes.reason);
          }

          //  Auction Book client and Auction Book antier 
          if (
            auctionBookRes.status === "fulfilled" &&
            bookRes.status === "fulfilled"
          ) {
            // ***** Again Call Api To Add Total rows in limit *****
            const newRes= await getAuctionBook({
              action: "iBids_GetBidsByAuctionPagination",
              auction_id: auctionId,
              pageIndex: 1,
              pageCount: auctionBookRes?.value?.TotalRows,
            })
            //*****  In this step we merge data and remove duplicate users *****
            const userIdSet = new Set([
              ...(bookRes.value?.data?.influencer_ids || []),
              ...(bookRes.value?.data?.referralUserIds || []),
            ]);
            // ***** In this step we filter data from userID *****
            const filteredRows = newRes?.rows?.filter(
              ({ UserId }) => userIdSet.has(UserId)
            );
            setAllAuctionBook(filteredRows)
            // ***** And Last,  this step is for custom pagination  *****
            const displayedData = filteredRows.slice(
              currentPage * limit,
              (currentPage + 1) * limit
            );
            setAuctionBookData({
              rows: displayedData || [],
              TotalRows: filteredRows?.length || 0,
            });
          } else {
            console.error(
              "API ERROR IN EITHER AUCTION BOOK CLIENT OR AUCTION BOOK ANTIER",
              {
                auctionBookError:
                auctionBookRes.status === "rejected"
                ? auctionBookRes.reason
                : null,
                bookError:
                bookRes.status === "rejected" ? bookRes.reason : null,
              }
            );
          }
        }
      } catch (error) {
        console.error("Unexpected error:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [auctionId]);

    // HANDLE CUSTOM PAGINATION FOR INFLUENCER AUCTION BOOK 
    const handlePageClick = ({ selected }) => {
      setCurrentPage(selected);
      const displayedData = allAuctionBook?.slice(
        selected * limit,
        (selected + 1) * limit
      );
      setAuctionBookData({
        rows: displayedData || [],
        TotalRows: allAuctionBook?.length || 0,
      });
    };

  const showTimeFun = (status, auctionDate) => {
    switch (status) {
      case "Progress":
        return <Countdown date={auctionDate} />;
      case "Ended":
        return `Auction Ended`;
      case "Scheduled":
        return ` ${moment(auctionDate).format("MMMM Do YYYY")}`;
      default:
        return true;
    }
  };

  const handleRefferalCode = async () => {
    try {
      const getReferralRes = await getReferralCode(auctionId);
      if (getReferralRes?.status === 200 || getReferralRes?.status === 200) {
        setReferralCode(getReferralRes?.data?.referral_code);
      } else {
        console.log("***API ERROR***");
      }
    } catch (error) {
      console.log(error, "error");
    }
  };
  useEffect(() => {
    if (invitationStatus === "ACCEPTED") {
      handleRefferalCode();
    }
  }, [invitationStatus]);

  // *********** HANDLE PAGE***********
  const handlePage = async ({ selected }) => {
    try {
      setLoadingBook(true);
      const page = selected + 1;
      const auctionBookRes = await getAuctionBook({
        action: "iBids_GetBidsByAuctionPagination",
        auction_id: auctionId,
        pageIndex: page,
        pageCount: limit,
      });
      if (auctionBookRes) {
        setLoadingBook(false);
        setAuctionBookData({
          rows: auctionBookRes?.rows,
          TotalRows: auctionBookRes?.TotalRows,
        });
      } else {
        setLoadingBook(false);
        console.log("***** API ERROR *****");
      }
    } catch (error) {
      setLoadingBook(false);
      console.log(error, "error");
    }
  };

  // *********** TIER INFO API ***********
  useEffect(() => {
    const tierInfo = async () => {
      const createFeesRes = await getTierInfo();
      setTierInfo(createFeesRes[0]);
    };
    tierInfo();
  }, []);

  return (
    <div className="influencer_analytics_page">
      {loading ? (
        <Loading />
      ) : (
        <Container>
          <div className="page_header">
            <button
              type="button"
              className="back_btn"
              onClick={() => navigate(-1)}
            >
              <LeftArrowIcon />
            </button>
            <h2>
              {auctionData?.issuerName} / <span>Auction ID {auctionId}</span>
            </h2>
          </div>
          <div className="page_details">
            <div className="page_details_img">
              {auctionData?.AuctionStatus === "Progress"&&<p className="live">
                <LiveIcon /> Live
              </p>}
              <img
                src={auctionData?.imgSrc?.[0] || defaultMusicbull}
                alt="thumnbnail"
              />
            </div>
            <div className="scheduled_portion">
              {
                <h4>
                  {auctionData?.AuctionStatus === "Scheduled"
                    ? "Scheduled "
                    : auctionData?.AuctionStatus === "Progress"
                    ? "Auction Ends in "
                    : ""}
                  <span>
                    {showTimeFun(
                      auctionData?.AuctionStatus,
                      auctionData?.AuctionStatus === "Progress"
                        ? auctionData?.endDate
                        : auctionData?.AuctionStatus === "Scheduled"
                        ? auctionData?.startDate
                        : ""
                    )}
                  </span>
                </h4>
              }
              {invitationStatus === "PENDING" &&auctionData?.AuctionStatus !== "Ended"&& (
                <Link
                  onClick={(e) => {
                    e.preventDefault();
                    setShow(true);
                  }}
                >
                  Auction Page
                </Link>
              )}
              {invitationStatus === "REJECTED" && (
                <div className="status-container">
                  <span className="rejected-status">REJECTED</span>
                </div>
              )}
              {show && (
                <Auctionmodal
                  show={show}
                  handleClose={() => setShow(false)}
                  auctionData={auctionData}
                  state={state}
                  setInvitationStatus={setInvitationStatus}
                  tierInfo={tierInfo}
                />
              )}
              {invitationStatus === "ACCEPTED" &&
                auctionData?.AuctionStatus !== "Ended" && (
                  <div className="copy_box">
                    <p>Copy this code and share it with your group</p>
                    <button
                      type="button"
                      onClick={() => {
                        toast.success("Referral Copied!");
                        const code = `${window.location.origin}/auth/register?step=1&referral=${referralCode}`;
                        navigator.clipboard.writeText(code);
                      }}
                    >
                      <CopyIcon />
                      Copy
                    </button>
                    {referralCode}
                  </div>
                )}
            </div>
            <div className="auction_commission">
              <h4>Auction Commission</h4>
              <Table responsive>
                <thead>
                  <tr>
                    <th>Tier</th>
                    <th>Monthly Listeners</th>
                    <th>Commission</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Tier {auctionData?.listingTier??3}</td>
                    <td>
                      {auctionData?.listingTier === "1" &&
                        `${formatCommaNumbers(tierInfo?.tier1_min
                        )} and ${formatCommaNumbers(tierInfo?.tier1_max)}`}
                      {auctionData?.listingTier === "2" &&
                        `${formatCommaNumbers(tierInfo?.tier2_min
                        )} to ${formatCommaNumbers(tierInfo?.tier2_max)}`}
                      {auctionData?.listingTier === "3" &&
                        `${formatCommaNumbers(tierInfo?.tier3_min
                        )} to ${formatCommaNumbers(tierInfo?.tier3_max)}`}
                        {!auctionData?.listingTier  &&
                        `${formatCommaNumbers(tierInfo?.tier3_min
                        )} to ${formatCommaNumbers(tierInfo?.tier3_max)}`}
                    </td>
                    <td>{state?.auctionCommision}%</td>
                  </tr>
                </tbody>
              </Table>
              {invitationStatus === "ACCEPTED" && (
                <h5>
                  Accept Date{" "}
                  <span>
                    {moment(state?.invitationData?.invitation_date).format(
                      "DD MMMM YYYY"
                    )}
                  </span>
                </h5>
              )}
            </div>
          </div>
          <hr className="custom_hr" />
          {/* <div className="analytics_sec">
            <h3>Analytics</h3>
            <div className="analytics_graph">
              <img src={graph} alt="graph" />
              <ul>
                <li className="youTube">YouTube</li>
                <li className="instagram">Instagram</li>
                <li className="tikTok">TikTok</li>
              </ul>
            </div>
            <Table responsive className="custom_table">
              <thead>
                <tr>
                  <th>Source</th>
                  <th>Total Traffic</th>
                  <th>Conversion</th>
                  <th>Expected Commission</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <Link
                      to="#"
                      rel="noreferrer"
                      onClick={(e) => e.preventDefault()}
                    >
                      Youtube
                    </Link>
                  </td>
                  <td>12</td>
                  <td>22.00%</td>
                  <td>$45.00</td>
                </tr>
                <tr>
                  <td>
                    <Link
                      to="#"
                      rel="noreferrer"
                      onClick={(e) => e.preventDefault()}
                    >
                      Instagram
                    </Link>
                  </td>
                  <td>12</td>
                  <td>22.00%</td>
                  <td>$45.00</td>
                </tr>
                <tr>
                  <td>
                    <Link
                      to="#"
                      rel="noreferrer"
                      onClick={(e) => e.preventDefault()}
                    >
                      TikTok
                    </Link>
                  </td>
                  <td>12</td>
                  <td>22.00%</td>
                  <td>$45.00</td>
                </tr>
                <tr>
                  <td>
                    <Link
                      to="#"
                      rel="noreferrer"
                      onClick={(e) => e.preventDefault()}
                    >
                      Other
                    </Link>
                  </td>
                  <td>12</td>
                  <td>22.00%</td>
                  <td>$45.00</td>
                </tr>
              </tbody>
            </Table>
            <h4>
              Estimate Total <span>$352.00</span>
            </h4>
            <p className="note_txt">
              Note: Total will be adjusted based on Winning bids Only once the
              auction is closed
            </p>
          </div> */}
          {/* <hr className="custom_hr" /> */}
          <div className="auction_book">
            <h3>Auction Book</h3>
            <Table className="custom_table" responsive>
              {loadingBook ? (
                <Loading />
              ) : (
                <tbody>
                  {auctionBookData && auctionBookData?.rows?.length > 0 ? (
                    auctionBookData?.rows?.map((data) => (
                      <tr>
                        <td>
                          {data?.date
                            ? moment.utc(data?.date).format("DD MMMM YYYY, hh:mm A")
                            : "N/A"}
                        </td>
                        <td>${data?.current_bid_price || 0.0}</td>
                      </tr>
                    ))
                  ) : (
                    <p>No Records Found</p>
                  )}
                </tbody>
              )}
            </Table>
            {auctionBookData?.TotalRows > limit && (
              <CMAuctions>
                <section className="pagination custom_pagination">
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel=""
                    previousLabel=""
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={3}
                    pageCount={Math.ceil(auctionBookData?.TotalRows / limit)}
                    renderOnZeroPageCount={null}
                    forcePage={currentPage}
                  />
                </section>
              </CMAuctions>
            )}
          </div>
          {/* <hr className="custom_hr" />
        <div className="rating_details">
          <h3>Rating Details </h3>
          <ul>
            <li>
              <div className="rating_details_box">
                <div className="rating_details_box_stars">
                  {Array.from({ length: 5 }).map((_, index) => (
                    <StarIcon
                      className={`${index === 4 ? "active" : ""} star_icon`}
                      key={index}
                    />
                  ))}
                  <p>1.0</p>
                </div>
                <p className="desc_txt">
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen book. It has survived not only{" "}
                </p>
              </div>
            </li>
          </ul>
        </div> */}
        </Container>
      )}
    </div>
  );
};

export default InfluencerAnalytics;
